module.exports = __webpack_public_path__ + "static/media/icon_accept.c59698b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_accept.svg
// module id = 866
// module chunks = 7